<template>
  <div class="backup-container h-100">
    <div class="custom-tab">
      <div class="custom-tab-header">
        <div>
          <span class="label">Backups</span>
        </div>
        <div class="d-flex-ac">
          <div class="text-right relative search-input-container">
            <b-input v-model="searchText" class=" mr-sm-2" id="search_text" type="text" placeholder="Search sites" />
            <div class="search-icon-container">
              <magnifier-icon class="icon-default search-icon"></magnifier-icon>
            </div>
          </div>
          <div class="text-right action-btn-cont" v-if="isCreateBackupAvailable()">
            <b-btn variant="primary px-3" class="btn-primary-1" @click="showCreateBackup">Create a New Backup</b-btn>
          </div>
        </div>
      </div>
      <div class="custom-tab-body nofooter">
        <div class="custom-tab-body-cont h-100" id="manualbackupscrollcontainer"  @scroll="scroll()">
          <div v-if="isLoading">
              <spinner size="small"></spinner>
          </div>
          <b-row v-for="(site,siteId) in backups" :key="siteId">
            <b-col class="backup-col">
              <b-row class="backup-item-row p-0">
                <b-col v-b-toggle="'accordion-' + siteId" :class="{'not-collapsed':!specificEntity['accordion-' + siteId]}" @click="showSpecificEntity('accordion-' + siteId, specificEntity['accordion-' + siteId])" class="backuprow collapsed">
                  <b-row>
                    <div class="col-1 p-0 parent-count text-center">
                      <span class="item-count">{{site.totalCount}}</span>
                    </div>
                    <div class="col-4  p-0 site-count-name no-wrap">
                      <span class="site-name" :title="site.siteName">{{site.siteName}}</span>
                    </div>
                    <div class="col repo-width p-0">
                      <span class="category-label">Repository</span>
                    </div>
                    <div class="col type-width p-0">
                      <span class="category-label">Type</span>
                    </div>
                    <div class="col size-width p-0">
                      <span class="category-label">Size</span>
                    </div>
                    <div class="col-3 date-width p-0">
                      <span class="category-label">Date</span>
                    </div>
                    <div class="col">
                    </div>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="detail-col">
                  <b-collapse :id="'accordion-'+siteId" role="tabpanel" v-if="specificEntity['accordion-'+siteId]" class="item-checkbox-details" style="width:100%">
                    <div>
                      <div v-for="(backup,type) in site.backups" :key="type" class="backup-detail-item-cont">
                        <div class="backup-detail-wrapper">
                          <div class="backup-type">
                            {{type | backupType}}
                          </div>
                          <div v-for="(backupTypes, index) in backup" :key="index">
                            <b-row v-for="(backupItem,index) in backupTypes" :key="index" class="backup-detail-item-row backup-item-row">
                              <b-col class="backup-name no-wrap p-0">
                                {{backupItem.backupNameDisplay}}
                              </b-col>
                              <b-col class="repo repo-width p-0">
                                <cloud-icon class="icon-default cloud"></cloud-icon>
                                <span class="">{{backupItem.repository}}</span>
                              </b-col>
                              <b-col class="type type-width p-0">
                                <files-db-icon v-if="backupItem.what=='full'" class="icon-default filesdb"></files-db-icon>
                                <files-icon v-if="backupItem.what=='files'" class="icon-default filesdb"></files-icon>
                                <db-icon v-if="backupItem.what=='db'" class="icon-default filesdb"></db-icon>
                                <span class="">{{backupItem.what | filetypes}}</span>
                              </b-col>
                              <b-col class="size size-width p-0">
                                <disk-icon class="icon-default disk"></disk-icon>
                                <span class="">{{backupItem.size}}
                                </span>
                              </b-col>
                              <b-col class="time date-width p-0">
                                <clock-simple-icon class="icon-default clocksimple"></clock-simple-icon>
                                <span class="">{{backupItem.time}}
                                </span>
                              </b-col>
                              <b-col class="d-flex justify-content-around action-width" v-if="isBackupActionAvailable()">
                                <a class="action-btn" @click="showRestorePrompt(backupItem)" v-b-tooltip.hover title="Restore">
                                  <restore-icon class="icon-default restore"></restore-icon>

                                </a>
                                <a class="action-btn" v-if="backupItem.repository == 'Server'" @click="downloadBackup(backupItem)" v-b-tooltip.hover title="Download">
                                  <download-icon class="icon-default download"></download-icon>
                                </a>
                                <a class="action-btn" @click="showDeletePrompt(backupItem, backupItem.method)" v-b-tooltip.hover title="Delete">
                                  <delete-icon class="icon-default delete-icon"></delete-icon>
                                </a>
                              </b-col>
                            </b-row>

                          </div>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

        </div>
        <empty-placeholder v-if="Object.keys(backups).length===0 && isLoading == false" v-bind="placeholderProps" @onBtnClick="showCreateBackup"></empty-placeholder>
      </div>
    </div>
    <restore-backup :backup="currentBackup" ref="restorebackupmodal"></restore-backup>
    <download-backup :backup="currentBackup" ref="downloadbackupmodal"></download-backup>
    <delete-modal @yes="deleteBackup" ref="deletemodal"></delete-modal>
    <create-backup ref="createBackup"></create-backup>
  </div>
</template>
<script>
import Vue from "vue";
import MagnifierIcon from '../../assets/lens.svg';
import CloudIcon from '../../assets/cloud.svg';
import FilesDbIcon from '../../assets/filesdb.svg';
import FilesIcon from '../../assets/files.svg';
import DbIcon from '../../assets/db.svg';
import DiskIcon from '../../assets/disk.svg';
import ClockSimpleIcon from '../../assets/clocksimple.svg';
import RestoreIcon from '../../assets/restore.svg';
import DownloadIcon from '../../assets/download.svg';
import DeleteIcon from '../../assets/delete.svg';

import RestoreBackup from '../modals/RestoreBackup';
import DownloadBackup from '../modals/DownloadBackup';
import DeleteModal from '../modals/DeleteModal';
import CreateBackup from '../protect/CreateBackup';

import EmptyPlaceholder from '../Common/EmptyPlaceholder';
import { EventBus } from '../../event/event-bus.js';
import _ from 'lodash';
export default {
  name: 'Backups',
  components: {
    MagnifierIcon,
    CloudIcon,
    FilesDbIcon,
    DiskIcon,
    ClockSimpleIcon,
    RestoreIcon,
    DownloadIcon,
    DeleteIcon,
    FilesIcon,
    DbIcon,
    RestoreBackup,
    DownloadBackup,
    DeleteModal,
    CreateBackup,
    EmptyPlaceholder
  },
  filters: {
    filetypes: value => {
      if (!value) return '';
      value = value.toString();
      if (value === 'full') {
        return 'Files & DB';
      }
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    backupType: value => {
      if (value === 'schedule') {
        return 'Schedule Backups';
      }
      if (value === 'manual') {
        return 'Manual Backups';
      }
      if (value === 'others') {
        return 'Other Backups (Backups from deleted schedules & backups from reconnected sites are shown below)';
      }
      return '';
    }
  },
  data() {
    return {
      searchText: '',
      entity: {},
      currentBackup: {},
      placeholderProps: {
        text:
          "No backups found here. \n\nYou can create a new backup by clicking on the 'Create a New Backup' button above.",
        type: 'neutral'
      },
      currentBackupMethod: '',
      allBackups: {},
      specificEntity : [],
      paginate: 0,
      dynamicPaginate: 0,
      isLoading: true
    };
  },
  mounted() {
    //this.showCreateBackup();
    this.loadBackups();
    let query = this.$route.query
    let querySiteID = query.show;
    if (querySiteID) {
      let site = _.find(this.getSelectedSites, { siteID: querySiteID });
      this.searchText = site.name;
    }
    EventBus.$on('view-backups', data => {
        if (data) {
          this.searchText = data;
        }
    });

    let elmnt = document.getElementById("manualbackupscrollcontainer");
    let height = elmnt.offsetHeight;
    let total = height/40;
    if (total ==0 ) {
      total = 20;
    }
    this.paginate = parseInt(total)+5;
    this.dynamicPaginate = this.paginate;
  },
  computed: {
    getSelectedSites() {
      return this.$store.getters.selectedSites;
    },
    backups() {
      let selectedSites = this.getSelectedSites;
      let allBackups = this.allBackups;
      let backups = {};
      let increment = 1;
      _.each(allBackups, (backup, siteId) => {
        let site = _.find(selectedSites, { siteID: siteId });
        if (this.dynamicPaginate <= increment) {
          return false;
        }
        if (
          site &&
          site.name &&
          site.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
        ) {
          backups[siteId] = {};
          backups[siteId] = backup;
          backups[siteId].siteName = site.name;
          increment++;
        }
      });
      backups = _.sortBy(backups, [data => data.siteName.toLowerCase()]);
      return backups;
    },
    currentUserInfo(){
      return this.$store.getters.getCurrentUserInfo;
    }
  },
  methods: {
    loadBackups() {
      let payload = {};
      payload.requiredData = {
        getSitesBackupsV3: 1
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.allBackups = response.data.getSitesBackupsV3;
        this.isLoading = false;
      });
    },
    showRestorePrompt(backupItem) {
      this.currentBackup = backupItem;
      this.$refs.restorebackupmodal.$refs.restorebackupmodal.show();
    },
    downloadBackup(backupItem) {
      if (_.isObject(backupItem.downloadURL)) {
        this.currentBackup = backupItem;
        this.$refs.downloadbackupmodal.$refs.downloadbackupmodal.show();
      } else {
        return window.open(backupItem.downloadURL, '_blank');
      }
    },
    showDeletePrompt(backupItem, method) {
      this.currentBackup = backupItem;
      this.currentBackupMethod = method;
      this.$refs.deletemodal.$refs.deletemodal.show();
    },
    deleteBackup() {
      this.$refs.deletemodal.$refs.deletemodal.hide();
      let payload = {
        requiredData: {
          getSitesBackupsV3: 1
        },
        action: 'removeBackup'
      };
      let taskName = this.currentBackup.task_name;
      payload.args = {
        params: {
          taskName: taskName,
          resultID: this.currentBackup.referenceKey
        },
        siteIDs: [this.currentBackup.siteID]
      };
      if (this.currentBackupMethod == 'Phoenix') {
         payload.args.params.isNewBackup = true;
       }
      this.$store.dispatch('sendAction', payload).then(response => {
        // this.$store.commit('SET_BACKUPS', response.data.getSitesBackupsV3);
      });
    },
    showCreateBackup() {
      this.$refs.createBackup.$refs.createBackupModal.show();
    },
    isCreateBackupAvailable(){
      if (this.currentUserInfo.accessLevel == 'admin'){
        return true;
      }
      return _.indexOf(this.currentUserInfo.permissions.access,'createBackup') > -1
    },
    isBackupActionAvailable(){
      if (this.currentUserInfo.accessLevel == 'admin'){
        return true;
      }
      return _.indexOf(this.currentUserInfo.permissions.access,'restoreDeleteDownloadBackup') > -1
    },
    showSpecificEntity(index, existingEntity){
      if (typeof existingEntity != 'undefined' && existingEntity != null && existingEntity == true) {
        this.specificEntity[index] = false;
        this.$root.$emit('bv::toggle::collapse', index);
      }else{
        this.specificEntity[index] = true;
      }
      Vue.nextTick().then(() => {
        this.$forceUpdate();
      });
    },
    scroll () {
      let elmnt = document.getElementById("manualbackupscrollcontainer");
      let y = elmnt.scrollTop;
      let sh = elmnt.scrollHeight;
      let height = elmnt.offsetHeight;
      if ((sh-y) <= height) {
        this.dynamicPaginate+=this.paginate;
      }
    },
  },
  beforeDestroy(){
    delete this.allBackups;
    EventBus.$off('view-backups');
  }
};
</script>

<style scoped>
</style>
